import {Injectable, OnDestroy} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {BehaviorSubject} from 'rxjs/BehaviorSubject';


const UNKNOWN_ACTION: any = {
  action: '',
  active: false,
};


@Injectable()
export class GlobalActionButtonService implements OnDestroy {
// Initial State - No Properties loaded;
  private subject = new BehaviorSubject(UNKNOWN_ACTION);

 actionInfo$: Observable<any> = this.subject.asObservable();

  constructor() {
  }


  /**
   * Set Global Action
   * @param action
   */
  setActionButtonValue(action: any): void {
    if (action.active) {
    return this.subject.next(action);
    }
  }

  /**
   * Set Value of Global Action to UNKNOWN
   */
  resetGlobalActionButton() {
    this.subject.next(UNKNOWN_ACTION);
  }

  ngOnDestroy() {
    this.subject.next(UNKNOWN_ACTION);
  }


}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/local/global-actionButton.service.ts